@if (section(); as topStores) {
  <section class="sav-top-stores-section" aria-label="Event top stores">
    <div class="sav-top-stores-wrap">
      <h2>{{ topStores.heading }}</h2>
      <p>The stores running the strongest offers in this event</p>

      <div class="sav-top-store-list" appAutoScrollRow>
        @for (store of topStores.stores; track store.id) {
          <a [routerLink]="store.path" class="sav-top-store" [attr.aria-label]="store.name">
            <app-store-logo
              class="sav-top-store-logo"
              [logoUrl]="store.logoUrl"
              [name]="store.name"
              decorative
            />
          </a>
        }
      </div>
    </div>
  </section>
}
